// extracted by mini-css-extract-plugin
export default {"button-16":"LanguageButton_button-16__cVsS-"};